import React from 'react';
import { contact, profile } from '../../data/portfolio';
import './Contact.css';

function Contact() {
  return (
    <footer id="contact" className="contact-section" aria-labelledby="contact-title">
      <div className="contact-inner" role="region" aria-label="연락">
        <p className="contact-label">Contact</p>
        <h2 id="contact-title">함께 일할 기회를 기다립니다.</h2>
        <p className="contact-copy">
          Java/Spring 백엔드 개발과 금융 메시징 운영 경험이 필요한 팀이라면 편하게 연락해 주세요.
        </p>
        <div className="contact-links">
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
          <a href={contact.github} target="_blank" rel="noreferrer">GitHub <span aria-hidden="true">↗</span></a>
        </div>
        <div className="footer-note">
          <span>{profile.name}</span>
          <span>{profile.role}</span>
        </div>
      </div>
    </footer>
  );
}

export default Contact;
